import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No liquidity backend exists in this
// environment: venue incident status and the reviewer name were previously fabricated. See
// context/page_pipeline/BOARD.md wave 4 and context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLiquidityIncidentPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Liquidity Dashboard", href: "/treasury/liquidity" }], label: "Venue Incident" }}
      state={{
        title: "Venue incident detail is not available in this environment yet",
        description: "Venue incident tracking and status have no backend in this environment yet.",
      }}
    />
  );
}
